import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { BarGraphRuler } from './BarGraphRuler';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;
  max-width: 860px;
`;

const Bar = styled.div<{ $color: string; $progress: number; $delay: number }>`
  height: 36px;
  width: ${({ $progress }) => Math.max(0, Math.min($progress, 100)) ?? '0'}%;
  border-radius: 12px;
  background: ${({ $color }) => $color ?? '#b7ccff'};
  box-shadow: 1px 2px 2px 0px rgba(0, 0, 0, 0.25);
  transition: all 2.25s ease-out;
  transition-delay: ${({ $delay }) => ($delay ?? 0) + 5000}ms;
`;

type Props = {
  timeSpent: number;
  timeRemaining: number;
  timeSaved: number;
};

export const BarGraph = ({ timeSpent, timeRemaining, timeSaved }: Props) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsReady(true);
    }, 1500);
  }, []);

  return (
    <Container>
      <Bar $delay={200} $progress={isReady ? timeSpent : 0} $color="#0414A1" />
      <Bar $delay={100} $progress={isReady ? timeSaved : 0} $color="#3169F6" />
      <Bar $delay={0} $progress={isReady ? timeRemaining : 0} $color="#B7CCFF" />
      <BarGraphRuler />
    </Container>
  );
};
